module.exports = __webpack_public_path__ + "img/021.f2433ea8.jpg";